var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MobileMenu',{attrs:{"isShop":_vm.shop,"primaryLinks":_vm.primaryLinks,"secondaryLinks":_vm.secondaryLinks}})}
var staticRenderFns = []

export { render, staticRenderFns }